import pageType from 'Addons/search/pageType';
import type { ConfigGetter } from 'Models/uiConfig/requestTypes';

import {
  getPageType as getShopifyPageType,
  getSearchPageUrl,
  getThemeInfo,
  isInDesignMode,
} from './platformHelpers';

const shopifyToConvermaxPageTypeMap: Record<string, string> = {
  home: pageType.home,
  collection: pageType.category,
  vendors: pageType.brand,
  product: pageType.product,
};

type PageTypeGetter = ConfigGetter<[], string, { getter: () => string }>;

const getPageType: PageTypeGetter = () => {
  const pageTypeShopify = getShopifyPageType();
  if (pageTypeShopify) {
    return shopifyToConvermaxPageTypeMap[pageTypeShopify] || pageType.unknown;
  }

  console.warn('Page type not found');
  return pageType.unknown;
};

getPageType.defaults = { getter: getPageType };

export default {
  searchPageUrl: getSearchPageUrl(),
  page: { getPageType },
  isInDesignMode,
  themeInfo: getThemeInfo(),
};
